import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Countdown from "@/components/Countdown";
import BookShowcase from "@/components/BookShowcase";
import Manifesto from "@/components/Manifesto";
import AuthorSection from "@/components/AuthorSection";
import OtherBooks from "@/components/OtherBooks";
import Formats from "@/components/Formats";
import Retailers from "@/components/Retailers";
import SiteFooter from "@/components/SiteFooter";

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App grain bg-[#0a0805] min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Countdown />
        <BookShowcase />
        <Manifesto />
        <AuthorSection />
        <OtherBooks />
        <Formats />
        <Retailers />
      </main>
      <SiteFooter />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Toaster position="bottom-center" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
